import React from 'react';

const Headline = props => {
  const subline = props.subline ? <h3>{props.subline}</h3> : null;
  let HeaderTag = props.headerTag;
  if (!HeaderTag) {
    HeaderTag = 'h2';
  }
  return (
    <React.Fragment>
      <HeaderTag>{props.headline}</HeaderTag>
      {subline}
    </React.Fragment>
  );
};
export default Headline;



// WEBPACK FOOTER //
// ./src/Component/Headline.js